/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Architect_Output9Inputs */

const en_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System architecture`)
};

const ar_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معمارية النظام`)
};

const bn_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিস্টেম আর্কিটেকচার`)
};

const de_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Systemarchitektur`)
};

const es_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura del sistema`)
};

const fr_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture du système`)
};

const pt_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura do sistema`)
};

const zh_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统架构`)
};

const tr_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistem mimarisi`)
};

const ru_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архитектура системы`)
};

const pl_svc_full_stack_web_apps_architect_output9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura systemu`)
};

/**
* | output |
* | --- |
* | "System architecture" |
*
* @param {Svc_Full_Stack_Web_Apps_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_architect_output9 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_architect_output9(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_architect_output9(inputs)
	return en_svc_full_stack_web_apps_architect_output9(inputs)
});
export { svc_full_stack_web_apps_architect_output9 as "svc_full-stack-web-apps_ARCHITECT_output" }